import { render, staticRenderFns } from "./comparison-bak.vue?vue&type=template&id=4a695a20&"
import script from "./comparison-bak.vue?vue&type=script&lang=js&"
export * from "./comparison-bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports